// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {SVGIcon} from '@homeaway/react-svg';
import {SEARCH__16, GROUP__16} from '@homeaway/svg-defs';

import SearchFields from '../SearchFields/SearchFields';
import routerActions from '../../actions/router';

import './MobileSearchMegabox.less';

type DispatchProps = {
    search: typeof routerActions.search,
    locationSearch: typeof routerActions.locationSearch
};

type Props = DispatchProps;

export const dateFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
};

export const MobileSearchMegabox = ({search, locationSearch}: Props) => (
    <div className="MobileSearchMegabox box-shadow--nav border-border-color">
        <SearchFields
            fieldClassName="MobileSearchMegabox__searchField"
            onChange={search}
            onLocationChange={locationSearch}
            searchIcon={<SVGIcon markup={SEARCH__16} />}
            guestpickerConfig={{
                guestsIcon: <SVGIcon markup={GROUP__16} />
            }}
            datepickerConfig={{
                consolidateInputs: false,
                dateFormatOptions,
                dateTextDescriptorInput1: {
                    defaultText: 'Arrive',
                    messageId: 'arrive'
                },
                useFloatingLabel: false
            }}
        />
    </div>
);

const mapDispatchToProps = {
    search: routerActions.search,
    locationSearch: routerActions.locationSearch
};

export default compose(
    connect(
        null,
        mapDispatchToProps
    )
)(MobileSearchMegabox);
